import Vue from "vue";
import Vuex from "vuex";
import router from "./router";
import appConfig from "@/assets/js/appConfig.js";

Vue.use(Vuex);

// const moduleA = {
//   state: { aa:123456 }
// }

var store = new Vuex.Store({
  // modules: {
  //   a: moduleA,
  // },
  state: {
    lang: localStorage.lang || "zh-CN",
    appConfig: appConfig,
    session: {
      token: null,//access_token,也可用于判断登录状态
      host_token: null,//用于模拟登录后，保存原本后管账户的token，可用于判断是否处于模拟登录
      host_token_admin: null,//用于模拟登录后，判断原本后管账户是不是管理员
      user: {},//id avatar display_name mobile is_backend description pre_company_name pre_business_tag_id pre_business_tag manager_shichang manager_caigou country
      tenant: null,//无tenant则为null
      tenant_auth: null,
      role_list: [],
      permission_list: [],
    },
    unread_count: {
      all: 0,
      forum_discuss: 0
    },
    notifyTimer: null,
    socket: null,
    loading: false,
    axiosPromiseCancelArr: [],
    basicInfo: {
      cityList: appConfig.cityList,
      countryList: appConfig.countryList,
      areaList: appConfig.areaList,
      characterList: appConfig.characterList,
      weight_methodList: appConfig.weight_methodList,
      have_warrantyList: appConfig.have_warrantyList,
      have_reportList: appConfig.have_reportList,
      credit_ratingList: appConfig.credit_ratingList,
      forge_typeList: appConfig.forge_typeList,
      categoryList: [],
      materialList: [],
      unitList: [],
      tagList: {
        pre_business: [],
        business_1: [],
        forum: [],
        good_business: [],
      }
    },
    headerFilter: "",

  },
  getters: {//VueX的计算属性
    checkPermission: (state) => (permission) => {
      return !permission || state.session.permission_list.indexOf(permission) != -1;
    },
    checkRole: (state) => (role) => {
      return state.session.role_list.indexOf(role) != -1;
    },
    checkRoleList: (state) => (roleList) => {
      return state.session.role_list.find(item => roleList.includes(item));
    },
    getCategory: (state) => (category_id) => {
      let category = state.basicInfo.categoryList.find(item => item.id == category_id);
      if (category) {
        return category.name;
      } else {
        return "";
      }
    }
  },
  mutations: {
    showLoading(state) {
      state.loading = true;
    },
    hideLoading(state) {
      state.loading = false;
    },
    setSession(state, param) {
      state.session[param.attr] = param.target;
    },
    getTags(state) {
      Vue.prototype.axios
        .get(`/api/tag/`, {
          noCancel: true,
          params: {
            size: 999,
          },
        })
        .then((data) => {
          state.basicInfo.tagList = {
            pre_business: data.results.filter(item => item.module == "pre_business"),
            business_1: data.results.filter(item => item.module == "business_1"),
            forum: data.results.filter(item => item.module == "forum"),
            good_business: data.results.filter(item => item.module == "good_business"),
          };
        });

    },
    addAxiosPromiseCancel(state, newCancel) {
      state.axiosPromiseCancelArr.push(newCancel);
    },
    clearAxiosPromiseCancel(state) {
      state.axiosPromiseCancelArr = [];
    },
    logout(state) {//401时的登出或用户主动登出
      state.session.token = null;
      state.session.host_token = null;
      state.session.host_token_admin = null;
      state.session.user = {};
      state.session.tenant = null;
      state.session.tenant_auth = null;
      state.session.role_list = [];
      state.session.permission_list = [];
      Vue.localStorage.remove("token");
      Vue.localStorage.remove("host_token");
      Vue.localStorage.remove("host_token_admin");
      router.push("/login");
    },
    updateUnreadNotify(state) {
      if (!state.session.token) return; //退出登录后不用调
      Vue.prototype.axios({
        method: 'get',
        url: '/api/user_message/unread_count/',
        showLoading: false
      }).then((data) => {
        state.unread_count = data;
      }).catch((err) => {
        console.log("err_unread_count", err);
      }).finally(() => {
        // console.log("complete")
        clearTimeout(state.notifyTimer);
        state.notifyTimer = setTimeout(() => {
          store.commit("updateUnreadNotify");
        }, 30000);
      });
    },
    getCategory(state) {
      Vue.prototype.axios
        .get("/api/product_category/", {
          noCancel: true
        })
        .then(function (data) {
          state.basicInfo.categoryList = data.category;
          state.basicInfo.materialList = data.material.map(item => item.name);
          state.basicInfo.unitList = data.unit;
        });
    },
    updateHeaderFilter(state, param) {
      state.headerFilter = param;
    }
  },
  actions: {
    updateSession(context) {
      return new Promise(resolve => {
        Vue.prototype.axios
          .get("/api/account/info/")
          .then(function (data) {
            store.setSession("user", {
              id: data.id,
              avatar: data.avatar,
              display_name: data.display_name,
              mobile: data.mobile,
              is_backend: data.is_backend,
              description: data.description,
              pre_company_name: data.pre_company_name,
              pre_business_tag_id: data.pre_business_tag_id,
              pre_business_tag: data.pre_business_tag,
              manager_shichang: data.manager_shichang,
              manager_caigou: data.manager_caigou,
              country: data.country,
              member_quotation_level: data.member_quotation_level,
              member_quotation_points: data.member_quotation_points,
              member_quotation_points_max: data.member_quotation_points_max,
              member_quotation_start_time: data.member_quotation_start_time,
              member_quotation_end_time: data.member_quotation_end_time,
              member_purchase_level: data.member_purchase_level,
              member_purchase_points: data.member_purchase_points,
              member_purchase_points_max: data.member_purchase_points_max,
              member_purchase_start_time: data.member_purchase_start_time,
              member_purchase_end_time: data.member_purchase_end_time,
            });
            store.setSession("tenant", data.tenant);
            store.setSession("tenant_auth", data.tenant_auth);
            store.setSession("role_list", data.role_list);
            store.setSession("permission_list", data.permission_list);
          })
          .finally(function () {
            resolve();
          });
      });

    },
  },
});

store.setSession = function (attr, target) {
  store.commit("setSession", {
    attr,
    target
  });
};

store.getCategoryName = function (category_id) {
  var category = store.state.basicInfo.categoryList.find(item => item.id == category_id);
  if (category) {
    return category.name;
  } else {
    return "";
  }
};
export default store;